import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#652A4D',
                secondary: '#fcd34c',
            }
        }
        
    }
});
